import type { MechKey } from './keys';

export const tl: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mekanika · 2D',
  'panel.scene': 'Eksena',
  'panel.dims': 'Mga Parameter',
  'panel.style': 'Hitsura',
  'panel.action': 'Mga Kontrol',
  'style.body': 'Katawan',
  'style.vector': 'Mga Vector',
  'style.ground': 'Lupa',
  'style.forces': 'Ipakita ang mga puwersa',
  'style.trace': 'Ipakita ang bakas',
  'style.labels': 'Mga label ng vector',
  'hint.line1': 'I-click ang play para magsimula · i-drag ang mga katawan para ilipat',
  'hint.line2': 'Sandbox: pumili ng hugis, tapos i-click para ilagay',
  'scene.incline': 'Hilig na eroplano',
  'scene.projectile': 'Galaw ng proyektil',
  'scene.pendulum': 'Pendulum',
  'scene.springMass': 'Spring-mass na sistema',
  'scene.collisions': 'Mga banggaan',
  'scene.atwood': 'Makina ni Atwood',
  'scene.circular': 'Paikot na galaw',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'anggulo (°)',
  'dim.friction': 'alitan',
  'dim.mass': 'masa',
  'dim.massA': 'masa A',
  'dim.massB': 'masa B',
  'dim.velocity': 'bilis',
  'dim.angleLaunch': 'anggulo ng paglulunsad (°)',
  'dim.gravity': 'grabidad',
  'dim.gravityX': 'grabidad x',
  'dim.gravityY': 'grabidad y',
  'dim.length': 'haba',
  'dim.damping': 'pagpapabagal',
  'dim.spring': 'katigasan',
  'dim.restitution': 'restitusyon',
  'dim.radius': 'radius',
  'dim.speed': 'tulin',
  'action.play': 'I-play',
  'action.pause': 'I-pause',
  'action.step': 'Hakbang',
  'action.reset': 'I-reset',
  'action.speed': 'Bilis',
  'action.clear': 'Burahin',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Grabidad',
  'forceName.normal': 'Normal na puwersa',
  'forceName.friction': 'Puwersa ng alitan',
  'forceName.tension': 'Tensyon',
  'forceName.spring': 'Puwersa ng spring',
  'forceName.applied': 'Inilapat na puwersa',
  'forceName.air': 'Pagtutol ng hangin',
  'palette.box': 'Kahon',
  'palette.circle': 'Bola',
  'palette.ramp': 'Rampa',
  'palette.ground': 'Lupa',
  'palette.hint': 'Pumili ng hugis, tapos i-click ang canvas para ilagay.',
  'panel.forces': 'Mga puwersang nakita',
  'forces.empty': 'Wala pa — i-play ang eksena',
};
